<template>
  <HgModal
    v-model="isVisible"
    :closeOnBackgroundClick="true"
    data-cy="funnel-abandonment-modal"
    @close="emit('cancel')"
  >
    <template #title>{{ t('funnelAbandonmentModal.title') }}</template>
    <p :class="$style.description">
      {{ t('funnelAbandonmentModal.description', { address: formattedAddress }) }}
    </p>
    <template #footer>
      <HgButton theme="secondary-bordered" @click="emit('cancel')">
        {{ t('button.cancel') }}
      </HgButton>
      <HgButton :disabled="isCreatingProperty" @click="emit('confirm')">
        {{ t('funnelAbandonmentModal.viewEstimatedMarketValue') }}
      </HgButton>
    </template>
  </HgModal>
</template>

<script setup lang="ts">
import { trackingFeatureDisplayEvent } from '@/tracking/tracking';
import { TRACKING_ACTION, TRACKING_LABEL } from '@/tracking/types';
import { HgButton, HgModal } from '@smg-real-estate/domus';
import { computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  modelValue: boolean;
  formattedAddress: string;
  isCreatingProperty?: boolean;
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void;
  (event: 'confirm' | 'cancel'): void;
}>();

const { t } = useI18n();

const isVisible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const trackModalDisplay = (): void => {
  trackingFeatureDisplayEvent(
    TRACKING_ACTION.DISPLAY_HOMEOWNER_BANNER,
    TRACKING_LABEL.VALUATION_FUNNEL_AFTER_ADDRESS_ENTRY,
  );
};

onMounted(() => {
  if (props.modelValue) {
    trackModalDisplay();
  }
});

watch(
  () => props.modelValue,
  (isOpen) => {
    if (isOpen) {
      trackModalDisplay();
    }
  },
);
</script>

<style lang="scss" module>
.description {
  margin: 0;
  word-break: break-word;
}
</style>
